var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { TalentAttributeCategories, } from 'packages/talent/entities/TalentAttribute';
import { CandidateAttachedAttribute } from 'packages/talent/entities/CandidateAttachedAttribute';
import { AttributeHelper } from 'packages/utilities/AttributeHelper';
import { EntityBuilder } from '@decahedron/entity';
import { namespace } from 'vuex-class';
import { Job } from 'packages/v3/jobs/Job';
var jobsModule = namespace('jobs');
var ProfileAttributeEditor = /** @class */ (function (_super) {
    __extends(ProfileAttributeEditor, _super);
    function ProfileAttributeEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.currentlySelectedAttribute = null;
        _this.currentlySelectedCategory = null;
        _this.attributeCategories = TalentAttributeCategories;
        _this.editingAttribute = false;
        _this.attributeHelperService = new AttributeHelper();
        return _this;
    }
    Object.defineProperty(ProfileAttributeEditor.prototype, "candidateProfileAttributesInspectorTracking", {
        get: function () {
            return this.editingAttribute
                ? 'candidate-profile.candidate-attributes.edit-attribute'
                : 'candidate-profile.candidate-attributes.add-attribute';
        },
        enumerable: false,
        configurable: true
    });
    ProfileAttributeEditor.prototype.mounted = function () {
        if (!this.availableAttributes.find(function (attribute) { return attribute.category === 'other'; })) {
            this.attributeCategories = this.attributeCategories.filter(function (category) { return category !== 'other'; });
        }
    };
    ProfileAttributeEditor.prototype.getComparableAttributesInJob = function (category) {
        return this.attributeHelperService.getComparableAttributesInJob(category, this.job, this.candidatesAttributes);
    };
    ProfileAttributeEditor.prototype.getComparableAttributesNotInJob = function (category) {
        return this.attributeHelperService.getComparableAttributesNotInJob(category, this.job, this.candidatesAttributes);
    };
    ProfileAttributeEditor.prototype.getComparableAttributeLabel = function (comparableAttribute) {
        return this.attributeHelperService.getComparableAttributeLabel(comparableAttribute);
    };
    ProfileAttributeEditor.prototype.addAttribute = function () {
        this.$emit('addAttribute', this.currentlySelectedAttribute);
        this.editor.close();
    };
    ProfileAttributeEditor.prototype.openEditorInEditMode = function (attribute) {
        this.editingAttribute = true;
        this.currentlySelectedAttribute = EntityBuilder.buildOne(CandidateAttachedAttribute, attribute);
        this.currentlySelectedCategory = attribute.category;
        this.editor.open();
    };
    ProfileAttributeEditor.prototype.updateAttribute = function (attribute) {
        this.$emit('updateAttribute', attribute);
        this.editor.close();
        this.editingAttribute = false;
    };
    ProfileAttributeEditor.prototype.removeAttribute = function (attribute) {
        this.$emit('deleteAttribute', attribute);
    };
    ProfileAttributeEditor.prototype.openEditor = function (category) {
        this.editingAttribute = false;
        this.currentlySelectedAttribute = null;
        this.currentlySelectedCategory = category;
        this.editor.open();
    };
    ProfileAttributeEditor.prototype.getAvailableAttributesByCategory = function (category) {
        return this.availableAttributes.filter(function (attribute) { return attribute.category === category; });
    };
    ProfileAttributeEditor.prototype.getReadableAttributeValue = function (attribute, attributeValue) {
        if (attributeValue == null) {
            return this.$t('common.unknown');
        }
        return this.attributeHelperService.getReadableAttributeValue(attribute, attributeValue);
    };
    ProfileAttributeEditor.prototype.setDefaultAttributeValue = function () {
        if (this.currentlySelectedAttribute && this.currentlySelectedAttribute.type === 'bool') {
            return this.currentlySelectedAttribute.value = 1;
        }
        if (this.currentlySelectedAttribute && this.currentlySelectedAttribute.type === 'scale') {
            return this.currentlySelectedAttribute.value = this.currentlySelectedAttribute.metadata.options[0].id;
        }
    };
    var _a;
    __decorate([
        jobsModule.State,
        __metadata("design:type", typeof (_a = typeof Job !== "undefined" && Job) === "function" ? _a : Object)
    ], ProfileAttributeEditor.prototype, "job", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Boolean)
    ], ProfileAttributeEditor.prototype, "hasJobContext", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], ProfileAttributeEditor.prototype, "candidatesAttributes", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Array)
    ], ProfileAttributeEditor.prototype, "availableAttributes", void 0);
    __decorate([
        Ref(),
        __metadata("design:type", Object)
    ], ProfileAttributeEditor.prototype, "editor", void 0);
    __decorate([
        Watch('currentlySelectedAttribute', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ProfileAttributeEditor.prototype, "setDefaultAttributeValue", null);
    ProfileAttributeEditor = __decorate([
        Component
    ], ProfileAttributeEditor);
    return ProfileAttributeEditor;
}(Vue));
export default ProfileAttributeEditor;
